import { render, staticRenderFns } from "./DocHubResourceForm.vue?vue&type=template&id=12135e4e"
import script from "./DocHubResourceForm.vue?vue&type=script&lang=js"
export * from "./DocHubResourceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports